import { render, staticRenderFns } from "./OrderStatusBadge.vue?vue&type=template&id=6bedfe55"
import script from "./OrderStatusBadge.vue?vue&type=script&lang=js"
export * from "./OrderStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusBadge.vue?vue&type=style&index=0&id=6bedfe55&prod&global=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports